module.exports = __webpack_public_path__ + "img/inge-v6-5.f9aa742c.png";